import { RouterManager } from '@aclass/admin/managers';
import { SettingsStory } from '@aclass/admin/storage/actions';
import { IAdminState, ISettingsModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class Page404SearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:page-404-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<ISettingsModuleState['search404PageInitialized']>(['settingsModule', 'search404PageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(Page404SearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(SettingsStory.dryRunSearch404Page());
    }
}
